import { FC } from "react";

import { AsyncFilterableSinglePicker } from "src/components/Inputs/AsyncFilterableSinglePicker";
import { useLazySearchUsersQuery } from "src/graphql/anti-fraud/queries/users/SearchUsersQuery";
import { mapToUser } from "src/mappers/user.mappers";
import { User } from "src/types/user";

export type UsersFilterableSinglePickerProps = {
  id?: string;
  selectedUser: User | null;
  onChange: (users: User | null) => void;
  invalid?: boolean;
  invalidText?: string;
  helperText?: string;
  label?: string;
  placeholder?: string;
  readOnly?: boolean;
};

export const UsersFilterableSinglePicker: FC<UsersFilterableSinglePickerProps> = ({
  id,
  selectedUser,
  onChange,
  invalid,
  invalidText,
  helperText,
  label,
  placeholder,
  readOnly = false,
}) => {
  const [searchUsers, { error }] = useLazySearchUsersQuery({});

  const loadOptions = async (search: string) => {
    const { data } = await searchUsers({ variables: { search, limit: 20 } });
    return data?.searchUsers.map(mapToUser) ?? [];
  };

  return (
    <AsyncFilterableSinglePicker
      id={id}
      readOnly={readOnly}
      invalid={invalid}
      invalidText={invalidText}
      helperText={helperText}
      placeholder={placeholder}
      label={label}
      getOptionLabel={(user) => user.name}
      getOptionValue={(user) => user.id}
      value={selectedUser}
      loadOptions={loadOptions}
      loadingOptionsError={!!error}
      onChange={onChange}
    />
  );
};
